import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { getPortfolioHoldPath } from '../../../../../../../../../features/portfolio/hold/portfolio-hold-routing';
import { AccountBreadcrumb } from '../../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/hold/_hold')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-${params.accountId}-hold-list`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: getPortfolioHoldPath({ kind: 'list', keys: { accountId: params.accountId } }),
      }),
    }) satisfies AggregateBreadcrumb,
});
